import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Table, message, Skeleton, Button, Tag, Space } from "antd";
import { getFirebaseApp, getProjectName } from "../../services/firebase";
import { Breadcrumb } from "@themesberg/react-bootstrap";
import { useEffect } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import { REPORT_TYPE } from "../../config/Const";

const ReportUsers = () => {
  let history = useHistory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
    return () => {};
  }, []);

  const fetchData = () => {
    getFirebaseApp()
      .firestore()
      .collection("reports")
      .where("created", ">=", moment("20210727").startOf("day").valueOf())
      .get()
      .then((res) => {
        setLoading(false);
        const val = res.docs.map((item) => ({ ...item.data(), id: item.id }));
        setData(val.filter((item) => item.status !== 0));
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message);
      });
  };

  const onClickId = (record) => () => {
    let id = "";
    let collection = "";
    switch (record.type) {
      case REPORT_TYPE.CONFESSION:
        id = record.confessionId;
        collection = "confession";
        break;
      case REPORT_TYPE.TASK:
        id = record.taskId;
        collection = "tasks";
        break;
      case REPORT_TYPE.CONFESSION_COMMENT:
        id = record.commentId;
        collection = `confession~2F${record.confessionId}~2Fcomments`;
        break;

      default:
        break;
    }

    if (
      record.type === REPORT_TYPE.CHAT ||
      record.type === REPORT_TYPE.CHAT_MESSAGE
    ) {
      history.push({
        pathname: Routes.Room.path,
        state: record,
      });
      return;
    }
    window.open(
      `https://console.firebase.google.com/u/0/project/${getProjectName()}/firestore/data/~2F${collection}~2F${id}`
    );
  };

  const onDone = (record) => () => {
    getFirebaseApp()
      .firestore()
      .collection("reports")
      .doc(record.id)
      .update({ status: 0 })
      .then(() => {
        fetchData();
        message.success("Success!");
      })
      .catch((err) => {
        message.warn(err);
      });
  };

  const onBlock = (record) => () => {
    history.push({
      pathname: Routes.BlockUser.path,
      state: record,
    });
  };

  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      fixed: "left",
      width: 150,
      filters: [
        {
          text: "Chat",
          value: REPORT_TYPE.CHAT,
        },
        {
          text: "Confession",
          value: REPORT_TYPE.CONFESSION,
        },
        {
          text: "Confession Comment",
          value: REPORT_TYPE.CONFESSION_COMMENT,
        },
      ],
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value, record) => record?.type?.indexOf(value) === 0,
      render: (tag) => {
        let color = "";
        switch (tag) {
          case REPORT_TYPE.CHAT:
            color = "geekblue";
            break;
          case REPORT_TYPE.CONFESSION:
            color = "green";
            break;
          case REPORT_TYPE.CONFESSION_COMMENT:
            color = "volcano";
            break;
          case REPORT_TYPE.TASK:
            color = "yellow";
            break;

          default:
            break;
        }
        return (
          <Tag color={color} key={tag}>
            {tag.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: "Content",
      dataIndex: "content",
      key: "content",
    },
    {
      title: "Id",
      key: "id",
      dataIndex: "id",
    },
    {
      title: "Reported User",
      key: "userId",
      dataIndex: "userId",
    },
    {
      title: "Created",
      dataIndex: "created",
      key: "created",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.created - b.created,
      render: (value) => (
        <a key={value}>{moment(value).format("DD/MM/YYYY")}</a>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 250,
      render: (record) => (
        <Space size="middle">
          <Button key={record.id} type="dashed" onClick={onDone(record)}>
            Done
          </Button>
          <Button key={record.id} type="primary" onClick={onBlock(record)}>
            Block
          </Button>
          <Button key={record.id} type="ghost" onClick={onClickId(record)}>
            Open
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Report Users</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      {loading ? (
        <Skeleton />
      ) : (
        <Table dataSource={data} columns={columns} scroll={{ x: 1300 }} />
      )}
    </>
  );
};
export default ReportUsers;
